import React, { useState, useEffect } from 'react';
import './Product.css';
import { useCart } from '../pages/js/CartContext';
import { API_BASE_URL } from '../API/endpoint';

function Product({ product, onClose }) {
  const { addToCart } = useCart();
  const [showMessage, setShowMessage] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [showImageModal, setShowImageModal] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1050);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 1050);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleImageClick = () => {
    if (isDesktop) {
      setShowImageModal(true);
    }
  };


  if (!product) return null;

  // Balisage Schema.org JSON-LD pour le SEO enrichi
  const schemaData = {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": product.title || product.name,
    "image": product.path ? [`${API_BASE_URL}${product.path}`] : [],
    "description": product.description || 'Réalisé à la main.',
    "sku": product.sku || '',
    "offers": {
      "@type": "Offer",
      "priceCurrency": "EUR",
      "price": product.price,
      "availability": "https://schema.org/InStock"
    },
    // Ajoutez ici d'autres propriétés si disponibles (note, avis, etc.)
  };

  return (
    <>
      {/* Balisage Schema.org pour Google (SEO) */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <div className="product-detail">
        <button className="close-button" onClick={onClose}>×</button>
        <h2 className="product-title">{product.title || product.name}</h2>
        <div 
          className="product-image-container" 
          onClick={handleImageClick}
          style={{ cursor: isDesktop ? 'pointer' : 'default' }}
        >
          {product.path && <img src={`${API_BASE_URL}${product.path}`} alt={product.title || product.name} />}
        </div>
        {showImageModal && isDesktop && (
          <div className="image-modal" onClick={() => setShowImageModal(false)}>
            <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="image-modal-close" onClick={() => setShowImageModal(false)}>×</button>
              <img src={`${API_BASE_URL}${product.path}`} alt={product.title || product.name} />
            </div>
          </div>
        )}
        <div className="product-content">
          <div className="product-info">
            <p className="product-description">{product.description || 'Réalisé à la main.'}</p>
            {/* <hr /> */}
            <p className="product-price">{parseFloat(product.price).toFixed(2)}€</p>
            <p className="product-shipping">Livraison: Collissimo 5.00€</p>
            {/* <hr /> */}
          </div>
          <div className="product-actions-wrapper">
            <div className="quantity-selector">
              <button onClick={() => setQuantity(Math.max(1, quantity - 1))}>-</button>
              <span>{quantity}</span>
              <button onClick={() => setQuantity(quantity + 1)}>+</button>
            </div>
            <div className="product-actions">
              <button className={`add-to-cart-button ${showMessage ? 'added' : ''}`} onClick={() => { addToCart(product, quantity); setShowMessage(true); setTimeout(() => setShowMessage(false), 2000); }}>AJOUTER AU PANIER</button>
              {showMessage && <span className="added-message">Ajouté !</span>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Product;